<chapter-step
  [title]="'Which method of time tracking works best for your team?' | translate"
  [nextButtonLoading]="nextButtonLoading"
  [nextButtonDisabled]="timeTrackingMethod.value === null"
  (next)="onNext()"
>
  <div class="flex flex-col gap-2">
    @for (option of timeTrackingMethods; track option.value) {
      <chapter-radio-button name="time-tracking-method" [control]="timeTrackingMethod" [data]="option" />
    }
  </div>
</chapter-step>
